import React from "react";

const ContactMapSection = () => {

    return (
        <>
            <section className="map-section">

                <div className="map-frame-wrap">

                    <div className="map-frame-glow"></div>

                    <iframe
                        title="Google Map"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3690.9081166310857!2d70.76535067529312!3d22.31931447967289!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3959c9e3e1a378a3%3A0xcc13a75e23cccd78!2sCode%20Buddy%27s!5e0!3m2!1sen!2sin!4v1783065849584!5m2!1sen!2sin%22"
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>

                </div>

                <style>{`

    .map-frame-wrap{
        position:relative;
        height:700px;
        width:100%;
        overflow:hidden;
        border:1px solid #f2f2f2;
        box-shadow:
        0 30px 80px rgba(0,0,0,.06);
        background:#fff;
    }

    .map-frame-wrap iframe{
        width:100%;
        height:100%;
        border:none;
        filter:grayscale(.1);
    }

    .map-frame-glow{
        position:absolute;
        inset:0;
        background:
        linear-gradient(
            180deg,
            rgba(255,255,255,.02),
            rgba(232,33,42,.06)
        );

        pointer-events:none;
        z-index:2;
    }

    @media(max-width:768px){

        .map-frame-wrap{
            height:420px;
            border-radius:24px;
        }

    }

`}</style>
            </section>
        </>
    );
};

export default ContactMapSection;